import React from 'react';

import { MCButton } from 'src/components/basic';
import constants from 'src/constants';
import { permissions } from 'src/helpers';

import mainModel from '../model';
import model from './model';

const Buttons = ({ appointment, doctor, params, loading }) => {
  const { PAGES, ACTIONS } = permissions;
  return (
    <>
      {ACTIONS.APPOINTMENTS_CANCEL_BUTTON.checkActive(params) && (
        <MCButton
          {...ACTIONS.APPOINTMENTS_CANCEL_BUTTON.attributes}
          medium
          disabled={loading}
          onClick={() => {
            mainModel.showCancel(appointment, () => {
              appointment.data.status = constants.general.appointmentStatus.cancelled;
              model.setState({ appointment });
            });
          }}
        />
      )}
      {ACTIONS.APPOINTMENTS_RESCHEDULE_BUTTON.checkActive(params) && (
        <MCButton
          {...ACTIONS.APPOINTMENTS_RESCHEDULE_BUTTON.attributes}
          type={'link'}
          medium
          to={PAGES.ADMIN_APPOINTMENTS_RESCHEDULE_PAGE.match(appointment.id)}
        />
      )}
      {ACTIONS.APPOINTMENTS_REBOOK_BUTTON.checkActive(params) && (
        <MCButton
          {...ACTIONS.APPOINTMENTS_REBOOK_BUTTON.attributes}
          medium
          type={'link'}
          to={permissions.PAGES.ADMIN_APPOINTMENTS_REBOOK_PAGE.match(doctor?.username)}
        />
      )}
    </>
  );
};


Buttons.displayName = 'Buttons';

export default Buttons;
